import script from "./CompanyAddView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyAddView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyAddView.vue?vue&type=style&index=0&id=27d9fbed&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d9fbed"]])

export default __exports__